<div class="mt-2 mb-4">
    <p class="default-font-size">
        <b>{{ getTranslatedSendGroupName(sendgroup.sendGroupName) }}</b>
        <span class="ms-2">
            <!-- has been Completed:-->
            <ng-container *ngIf="IsCompletedSendGroup">
                <ng-container *ngIf="HasCompletionDate">
                    <pillbadge-status-display
                        [data]="sendgroup.completionDate | valueByTypePipe : DataTypeEnum.CompletionDate"
                        [status]="'Success'" [iconTag]="'check2'"></pillbadge-status-display>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="!IsCompletedSendGroup">
                <!-- has an ACTIVE deadline:-->
                <ng-container *ngIf="HasDeadline">
                    <pillbadge-status-display [data]="sendgroup.deadline | valueByTypePipe : DataTypeEnum.DateTime"
                        [status]="'Warning'" [iconTag]="'stopwatch'"></pillbadge-status-display>
                </ng-container>

                <!-- has an FUTURE deadlineDAYS:-->
                <ng-container *ngIf="HasDeadlineDays">
                    <pillbadge-status-display [data]="sendgroup.deadlineDays | valueByTypePipe : DataTypeEnum.PlusDays"
                        [status]="'Warning'" [iconTag]="'stopwatch'" [disable]="true"></pillbadge-status-display>
                </ng-container>
            </ng-container>

            <!-- has been Invited/made Active:-->
            <!-- ACTION MENU: -->
            <div class="float-end d-block">
                <ng-container *ngIf="HasAnySendGroupActionEnabled">
                    <div class="dropdown">
                        <button class="btn btn-sm btn-outline-secondary" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <icon [icon]="'pencil'"></icon> <span translate="Button.Edit"></span>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end">
                            <li *ngIf="AllowsChangingSendGroupName"><a class="dropdown-item" (click)="editName()"
                                    translate="Button.Name"></a></li>
                            <li *ngIf="AllowsDeadlineEdit"><a class="dropdown-item" (click)="editDeadline()"
                                    translate="Button.Deadline"></a> </li>
                            <li *ngIf="AllowsResendInvites"><a class="dropdown-item" (click)="resendInvite()"
                                    translate="Button.Reminder"></a> </li>
                            <li *ngIf="AllowsDeadlineDaysEdit"><a class="dropdown-item" (click)="editDeadlineDays()"
                                    translate="Button.DeadlineDays"></a>
                        </ul>
                    </div>
                </ng-container>
            </div>
        </span>
    </p>

    <!-- TABLE FOR SENDGROUP -->
    <div class="w-100 sendGroup">
        <div>
            <ul class="d-none d-lg-block list-group" id={{sendgroup.sendGroupGuid}}>
                <li class="list-group-item subheader sg-actions d-block pt-1 pe-0 pb-1 ps-2">
                    <div class="row row-cols-10 w-100 d-flex p-0 align-items-center">
                        <div class="col-3 text-truncate firstcol"><span translate="Request.Status.Person"></span></div>
                        <div class="col-2 text-truncate"><span translate="Request.Status.Action"></span></div>
                        <div class="col-4 text-truncate"><span translate="Request.Status.Documents"></span></div>
                        <div class="col-2 text-truncate"><span translate="Request.Status.CompletionDate"></span></div>
                        <div class="col-1 text-end"></div>
                    </div>
                </li>

                <ng-container *ngFor="let actorInSendgroup of actorsInSendgroup; int let i = index; let isFirstItem = first; let isLastItem = last;">
                    <ng-container *ngIf="!actorInSendgroup.grouped">
                        <li class="list-group-item d-block pt-1 pe-0 pb-1 ps-2 subtable" [ngClass]="{'last-child': isLastItem}">
                            <desktop-request-status-sendgroup-action-row
                                [actorInSendgroup]="actorInSendgroup"></desktop-request-status-sendgroup-action-row>
                        </li>
                    </ng-container>
                    <ng-container *ngIf="actorInSendgroup.grouped">
                        <li class="list-group-item d-block pt-1 pe-0 pb-1 ps-2 subtable grouped"
                            (click)="collapseCurrentSendgroup(actorInSendgroup.personGuid)"
                            [ngClass]="{ 'last-child-collapsed': isLastItem && isCurrentSendGroupCollapsed(actorInSendgroup.personGuid), 'no-bottom-border': !isCurrentSendGroupCollapsed(actorInSendgroup.personGuid), 'last-child': isLastItem }">
                            <desktop-request-status-sendgroup-action-row [actorInSendgroup]="actorInSendgroup"
                                [overRuledStatus]="actorInSendgroup.overRuledStatus"></desktop-request-status-sendgroup-action-row>
                        </li>
                        <div #collapse="ngbCollapse"
                            [ngbCollapse]="isCurrentSendGroupCollapsed(actorInSendgroup.personGuid)"
                            [horizontal]="false"
                            [ngClass]="{ 'last-child-expanded': isLastItem && !isCurrentSendGroupCollapsed(actorInSendgroup.personGuid) }">
                            <!-- Expandable list of actions by person -->
                            <desktop-request-status-actions-by-person [lastItemOfPersonsInSendgroup]="isLastItem"
                                [actorsOfSendgroup]="getActionsByPerson(actorInSendgroup.personGuid)"></desktop-request-status-actions-by-person>
                        </div>
                    </ng-container>
                </ng-container>

            </ul>
        </div>
    </div>
</div>